import { defineMessages } from '@jutro/locale';

export default defineMessages({
    keyContactsHeader: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.Key Contacts',
        defaultMessage: 'Key Contacts'
    },
    claimsNumber: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.Claims Numbber',
        defaultMessage: 'Claims Number: (800) 854-6011'
    },
    namedInsured: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.NAMED INSURED',
        defaultMessage: 'NAMED INSURED'
    },
    claimConsultant: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.CLAIM CONSULTANT',
        defaultMessage: 'CLAIM CONSULTANT'
    },
    conatatPhone: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.Phone:',
        defaultMessage: 'Phone:'
    },
    ConatactFax: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.Fax:',
        defaultMessage: 'Fax:'
    },
    conatactEmail: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.EMail',
        defaultMessage: 'Email: {email}'
    },
    appraisalSource: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.APPRAISAL SOURCE',
        defaultMessage: 'APPRAISAL SOURCE'
    },
    serviceProvider: {
        id: 'ml.gateway.views.AccountClaims.KeyContacts.SERVICE PROVIDER',
        defaultMessage: 'SERVICE PROVIDER'
    },

});
